import * as Styles from './styles'

export const SkeletonText = () => <Styles.SkeletonText />
